module.exports = __webpack_public_path__ + "static/media/mp.451bfdba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/mp.svg
// module id = 194
// module chunks = 0